export const TELIA_TV_SALVESTUS_E = 'TELIA_TV_SALVESTUS_E';
export const TELIA_TV_FILMIRIIUL_E = 'TELIA_TV_FILMIRIIUL_E';
export const TELIA_VIDEOLAENUTUS_E = 'TELIA_VIDEOLAENUTUS_E';
export const TELIA_TV_NETFLIX_PREMIUM = 'TELIA_TV_NETFLIX_PREMIUM';
export const normalizeName = (originalTitle) => {
    return originalTitle.replace('_EST_', '').replace('_RUS_', '').replace('TOT', 'E');
};
export const replaceEmployeeTitleWithCustomerTitle = (originalTitle) => {
    return originalTitle.replace('_TOT', '_E');
};
export const getViewRequirementsByProductOfferingCode = (productOfferingCode, viewRequirements) => {
    var _a;
    if (!viewRequirements || !viewRequirements.length) {
        return null;
    }
    return (_a = viewRequirements.find((vr) => vr.productOfferingCode === replaceEmployeeTitleWithCustomerTitle(productOfferingCode))) === null || _a === void 0 ? void 0 : _a.content;
};
